import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

// ⭐ 스타일 적용
const Container = styled.div`
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  color: white;
  text-align: center;
`;

const MoviePoster = styled.img`
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 10px;
`;

const MovieTitle = styled.h1`
  font-size: 28px;
  margin-top: 20px;
  color: #1abc9c;
`;

const MovieInfo = styled.p`
  font-size: 16px;
  margin-top: 10px;
  color: #ecf0f1;
`;

function Detail() {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    fetch(`https://yts.mx/api/v2/movie_details.json?movie_id=${id}`)
      .then((response) => response.json())
      .then((data) => setMovie(data.data.movie));
  }, [id]);

  return (
    <Container>
      {movie ? (
        <>
          <MoviePoster
            src={movie.small_cover_image}
            alt={movie.title}
          />
          <MovieTitle>{movie.title}</MovieTitle>
          <MovieInfo>⭐ 평점: {movie.rating}</MovieInfo>
          <MovieInfo>⏳ 상영시간: {movie.runtime}분</MovieInfo>
          <MovieInfo>{movie.description_full}</MovieInfo>
        </>
      ) : (
        <MovieInfo>Loading...</MovieInfo>
      )}
    </Container>
  );
}

export default Detail;
